<template>
  <v-card
    elevation="0"
  >
    <v-list
      shaped
    >
      <v-subheader v-if="title" class="text-uppercase">{{ title }}</v-subheader>

      <v-list-item-group v-model="selected" color="primary">
        <!-- Default items -->
        <template v-for="(item, index) in items">
          <v-list-item
            :key="index"
            :to="item.to"
            :inactive="isInactive"
            :ripple="!isInactive"
            no-action
          >
            <!-- Icon -->
            <v-list-item-icon v-if="item.icon">
              <v-icon :color="item.iconColor">{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <!-- Content -->
            <v-list-item-content>
              <v-list-item-title :class="item.titleClasses">
                {{ item.title }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="item.subtitle" :class="item.subtitleClasses">
                {{ item.subtitle }}
              </v-list-item-subtitle>
            </v-list-item-content>

            <!-- Right content (like counts) -->
            <v-list-item-action v-if="item.count">
              <v-chip medium :color="item.chipColor">{{ item.count }}</v-chip>
            </v-list-item-action>
          </v-list-item>
        </template>

        <v-list-item
          v-if="!items.length"
          inactive
          :ripple="false"
        >
          <v-list-item-content>
            <div class="text-center grey--text">
              Aucune donnée disponible
            </div>
          </v-list-item-content>
        </v-list-item>

        <!-- Slot for custom items -->
        <slot name="items"></slot>
      </v-list-item-group>
    </v-list>
  </v-card>
</template>

<script>
export default {
  name: 'List',
  props: {
    title: {
      type: String,
      default: ''
    },
    items: {
      type: Array,
      default: () => []
    },
    isInactive: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return { selected: null };
  }
};
</script>
